<template>
  <div class="recovery-content">
    <main class="container">
      <a class="back-link" @click="$router.go(-1)"
        ><i class="icon-ic_arrow_left_blue" />Voltar</a
      >
      <div class="wrapper">
        <div class="img-container">
          <slot name="banner" />
        </div>
        <div class="text-content">
          <header>
            <slot name="contentHeader" />
          </header>
          <div class="content">
            <slot name="content" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'TemplateRecovery'
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.recovery-content {
  height: 100%;
  padding-top: 13.875rem;
  min-height: calc(100vh + 12.125rem);
  main {
    height: 100%;
    background: #ffffff;
    box-sizing: border-box;
  }
  .text-content {
    max-width: 25.625rem;
    padding: 1rem;
    margin: 0 auto;
    header {
      h2 {
        font-size: 1.25rem;
        font-weight: 500;
        margin-bottom: 1.25rem;

        color: var(--gray-700);
      }
      h3 {
        font-size: 1rem;

        color: var(--gray-700);
        line-height: 1.5rem;
      }
    }
  }
}

@media (min-width: 768px) {
  .recovery-content {
    min-height: 100%;
    .wrapper {
      display: flex;
      background-color: var(--bg-color-primary);
      justify-content: center;
      flex-wrap: wrap;
      > div {
        width: 50%;
      }
      .text-content {
        padding-top: 3rem;
      }
    }
  }
}
</style>
